import { bootstrapQZ } from '@goshippo/print';

import { quickpackApi } from '~/services/api';

import { setupPrintLifecycleRelay } from './printLifecycle.util';

// QZ Tray stamps each request's timestamp right before asking us to sign it,
// then rejects the request on delivery if that timestamp is older than its
// ~15-minute "VALID_SIGNING_PERIOD", found in their Java repo.
// The only way to hit that is for the machine to sleep mid-signing: the round-trip
// to `/devices/qz/signature` resolves on wake carrying a pre-sleep timestamp.
// We refuse any signature whose round-trip took far longer than a normal one —
// comfortably above real latency, comfortably under the validity window — so the
// stale request never reaches QZ. qz-tray then rejects the call as "Failed to
// sign request"; `retryOnTransientError` re-issues it with a fresh timestamp.
const STALE_SIGNATURE_THRESHOLD_MS = 2 * 60 * 1000;

let cachedCertificate: null | string = null;

const getCertificate = (resolve, reject) => {
  if (cachedCertificate !== null) {
    resolve(cachedCertificate);
    return;
  }

  quickpackApi
    .request<{ certificate: string }>({
      method: 'GET',
      url: '/devices/qz/certificate',
    })
    .then(({ data }) => {
      cachedCertificate = data.certificate;
      resolve(data.certificate);
    })
    .catch((error) => reject(error));
};

const sign = (toSign: string) => (resolve, reject) => {
  const requestedAt = Date.now();
  quickpackApi
    .request<{ signature: string }>({
      data: { to_sign: toSign },
      method: 'POST',
      url: '/devices/qz/signature',
    })
    .then(({ data }) => {
      if (Date.now() - requestedAt > STALE_SIGNATURE_THRESHOLD_MS) {
        reject(new Error('QZ signature discarded: signing spanned a sleep/freeze'));
        return;
      }
      resolve(data.signature);
    })
    .catch((error) => reject(error));
};

export const setupShippoPrint = () => {
  bootstrapQZ({
    certificateOptions: { rejectOnFailure: true },
    getCertificate,
    sign,
  });
  setupPrintLifecycleRelay();
};
